import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-brand-navy text-white mt-24" data-testid="site-footer">
            <div className="diagonal-stripes h-1.5 w-full" />
            <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <img
                        src="/tps-logo.jpg"
                        alt="Tower Staffing Inc. — Providing results through service"
                        className="h-16 bg-white p-2 rounded-sm"
                    />
                    <p className="mt-4 text-slate-300 max-w-md leading-relaxed">
                        Tower Staffing has been Fort Wayne's full–service employment agency since 1953.
                        Family-owned, ethics-driven, and committed to matching the right people with the right work.
                    </p>
                </div>
                <div>
                    <h4 className="font-heading uppercase font-bold tracking-wider mb-4 text-white">Quick Links</h4>
                    <ul className="space-y-2 text-slate-300">
                        <li><Link to="/jobs" className="hover:text-brand-orange">Browse Jobs</Link></li>
                        <li><Link to="/apply" className="hover:text-brand-orange">Apply Now</Link></li>
                        <li><Link to="/about" className="hover:text-brand-orange">About Us</Link></li>
                        <li><Link to="/contact" className="hover:text-brand-orange">Contact</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-heading uppercase font-bold tracking-wider mb-4 text-white">Contact</h4>
                    <ul className="space-y-3 text-slate-300">
                        <li className="flex gap-2"><Phone className="h-4 w-4 mt-1 text-brand-orange" />260.483.7085</li>
                        <li className="flex gap-2"><MapPin className="h-4 w-4 mt-1 text-brand-orange" />1501 Goshen Ave.<br />Fort Wayne, IN</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10 py-6 text-center text-xs text-slate-400 px-6">
                © {new Date().getFullYear()} Tower Staffing, Inc. All rights reserved.
                <Link to="/admin/login" className="ml-3 text-slate-500 hover:text-brand-orange" data-testid="footer-admin-link">Admin</Link>
            </div>
        </footer>
    );
}
